import { useAppDispatch } from "../../../../store/hooks";
import { changeColorValue, changeNumberValue } from "../../../../store/model";
import CheckListInput from "../../../Palettes/Propertybar/input/checkListInput";
import ColorInput from "../../../Palettes/Propertybar/input/colorInput";
import NumberInput from "../../../Palettes/Propertybar/input/numberInput";
import RadioSelectInput from "../../../Palettes/Propertybar/input/radioSelectInput";
import TextInput from "../../../Palettes/Propertybar/input/textInput";
import { getColorValue } from "../shapeHelper/getSetProperties";
import ShapePalette from "../ShapePalette";

const TextProperyPalette = ({ text }: { text: GeometricShape }) => {
    const textShape = text as TextShape;
    const dispatch = useAppDispatch();

    return (
        <ShapePalette shapeId={text.id}>
            <div className='property__element'>
                <ColorInput
                    properyDisplayName={"Text color"}
                    currentValue={getColorValue(textShape, "stroke")()}
                    setValue={(input: ColorValue) => {
                        console.log(input, "INPUT");

                        const actionPayload = {
                            id: textShape.id,
                            propertyValue: input,
                            propertyName: "stroke",
                        };
                        dispatch(changeColorValue(actionPayload));
                    }}
                />
            </div>
            <div className='property__element'>
                <TextInput
                    properyDisplayName="Text"
                    propertyName="uiText"
                    properyItem={text}
                />
            </div>
            <div className="property__element">
                <RadioSelectInput
                    properyDisplayName="Alignment"
                    propertyName="align"
                    properyItem={text as TextShape}
                />
            </div>
            <div className="property__element">
                <NumberInput
                    propertyDisplayName="Font Size"
                    setValue={
                        (number) => {
                            const payload = {
                                id: textShape.id,
                                propertyValue: number,
                                propertyName: "fontSize",
                            };
                            dispatch(changeNumberValue(payload));
                        }
                    }
                    currentValue={textShape.fontSize}
                />
            </div>
            {/* <div className="property__element">
                <NumberInput         
                    properyDisplayName="Rotation"
                    getValue={getNumberValue(text, "rot")}
                    setValue={setNumberValue(text, "rot")}
                />
            </div> */}
            <div className="property__element">
                <CheckListInput
                    properyItem={text}
                    options={["bold", "italic"]}
                />
            </div>

        </ShapePalette>
    )
};
const createPropertyPalette = (text: GeometricShape) => {
    return <TextProperyPalette text={text} />;
};

export default createPropertyPalette;